import BaseLayout from "@/layout/BaseLayout.vue";
import Layout1 from '@/pages/Articolo.vue' //Articolo
import Layout15 from '@/pages/ListaNotizie.vue' //Notizie e Eventi

export default [{
   path: '/notizie',
   name: "Notizie",               
   component: BaseLayout,  
   meta:{         
      layout: Layout15,
      params: true,
      tipologia: 'NotiziaPublished',
      breadcrumb:{
         label: "Notizie",
         parent: 'Home'
      } 
   },  
   children: [
   {
      path: '/notizie/:slug',
      name: 'notizia',
      meta:{  
         layout: Layout1,         
         parent: "notizie",
         area: 'notizia',
         params: true,
         props: true,
         breadcrumb() {
            const label = this.$route.params.title !== undefined ? this.$route.params.title : this.$root.title;
            return {                  
               label: label 
            };
         }     
      }
   }],
}];
